import { render, staticRenderFns } from "./ResumeProject.vue?vue&type=template&id=6b7ae3c8&scoped=true"
import script from "./ResumeProject.vue?vue&type=script&lang=js"
export * from "./ResumeProject.vue?vue&type=script&lang=js"
import style0 from "./ResumeProject.vue?vue&type=style&index=0&id=6b7ae3c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ae3c8",
  null
  
)

export default component.exports